import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import CloverSalesApis from "../config/cloverSalesApis";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const BasicTable = ({ intRitasStoreID, setUploadSuccess, setFile, previewData, startDate, endDate }) => {

    const [flavorsList, setFlavorsList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [dialogOpen, setDialogOpen] = useState(false); // Dialog visibility
    const [dialogMessage, setDialogMessage] = useState(""); // Dialog message
    // Fetch data based on intRitasStoreID prop
    useEffect(() => {
        
        const fetchData = async () => {
            if (!intRitasStoreID) return;

            try {
                setLoading(true);

                if (previewData.length !== 0) {
                    setUploadSuccess(true);
                    setFlavorsList(previewData || []);
                    setFile(null);
                } else {
                    setUploadSuccess(false);
                    setFlavorsList([]);
                    setFile(null);
                    const message = "No data available to preview";
                    enqueueSnackbar(message, {
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        },
                        variant: "error",
                    });
                }

            } catch (error) {
                console.error("Error fetching data:", error);
                setFlavorsList([]);
                const message = "Error While Loading Data";
                enqueueSnackbar(message, {
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "error",
                });
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [intRitasStoreID]); // Re-fetch data whenever intRitasStoreID changes

    const handleDialogClose = () => {
        const message = "Data Stored Successfully!!"
        enqueueSnackbar(message, {
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            variant: "success",
        });
        setDialogOpen(false); // Close dialog on action
        setUploadSuccess(false);
        setFlavorsList([]);
        setFile(null);
    };

    const onAccept = async () => {

        
        try {
            const response = await fetch(
                CloverSalesApis.nonCloverSalesUpdateSP,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ intRitasStoreID: intRitasStoreID, startDate: startDate, endDate: endDate }),
                }
            );

            
            if (response.ok) {
                const result = await response.json();
                const message = "Sales Data Uploaded Successfully!";
                // Set dialog message and open dialog
                setDialogMessage(message);
                setDialogOpen(true);
            } else {
                const message = "Request failed with status: " + response.error;
                enqueueSnackbar(message, {
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "error",
                });
            }
        } catch (error) {
            enqueueSnackbar(error, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "error",
            });


        }


    };

    const onReject = () => {
        const message = "Request Rejected!";
        enqueueSnackbar(message, {
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            variant: "error",
        });
        setUploadSuccess(false);
        setFlavorsList([]);
        setFile(null);
    };

    return (
        <div className="mt-16 py-6" style={{ overflowY: 'auto' }}>
            <header>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                        Sales Preview
                    </h1>
                    <div className="flex justify-between mt-2 mb-2">
                        <div>
                            <h1 className="text-xl font-display font-medium leading-tight text-secondary">
                                Records Count: {flavorsList.length}
                            </h1>
                        </div>
                        <div>
                            <button
                                size="small"
                                style={{ marginRight: "10px", height: "38px", backgroundColor: "green" }}
                                className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                                onClick={onAccept}
                            >
                                Accept
                            </button>
                            <button
                                style={{ height: "38px" }}
                                type="button"
                                onClick={onReject}
                                className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                            >
                                Reject
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div className="px-4 py-4 sm:px-0">
                        <div className="py-6">
                            <div className="overflow-hidden rounded-md shadow-md bg-white">
                                {/* Table container with scrollable body */}
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                        {/* Fixed thead */}
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Sales Date
                                                </th>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Product Type Name
                                                </th>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Product Size Name
                                                </th>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Quantity Sold
                                                </th>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Price
                                                </th>
                                                <th className="sticky top-0 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-gray-50 w-1/6">
                                                    Total
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Scrollable tbody */}
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        Loading...
                                                    </td>
                                                </tr>
                                            ) : flavorsList.length ? (
                                                flavorsList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            {item.SalesDate}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            {item.vchProductTypeName}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            {item.vchProductSizeName}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            {item.QuantitySold}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            ${item.mnyPrice.toFixed(2)}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                                            ${item.mnyPosSales.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        No data found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Fixed Grand Total Row */}
                            <div className="px-4 py-2 border-t bg-gray-50">
                                <div className="flex justify-end items-center">
                                    <span className="text-sm font-semibold text-gray-900 mr-2">
                                        Grand Total:
                                    </span>
                                    <span className="text-sm font-semibold text-gray-900">
                                        ${flavorsList.reduce((sum, item) => sum + item.mnyPosSales, 0).toFixed(2)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            {/* Dialog Component */}
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle>Operation Successful</DialogTitle>
                <DialogContent>
                    <p>{dialogMessage}</p>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleDialogClose}
                        sx={{
                            backgroundColor: "darkgreen",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "darkgreen", // Darker green on hover
                            },
                        }}
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>

    );
};

export default BasicTable;
